import {observer} from 'mobx-react-lite'
import * as React from 'react'
import {Lang} from 'yougile-lang'
import {Hub} from 'yougile-model'
import {Checkbox} from '@components/common/base/checkbox'
import {SelectWithDropdown} from '@components/common/base/select-with-dropdown'
import {SelectWithUsers} from '@components/common/base/select-with-dropdown/select-with-users'
import {menuItemHeight} from './constants'
import {getRemoveAssignedOptions} from './helpers/get-remove-assigned-options'
import {useMovementStore} from './movement-store'
import {TwAction} from './remove-assigned-actions'

interface Props {
  board: Hub
  destBoard?: Hub
}

export const SubscribersActions = observer(({board, destBoard}: Props) => {
  const [state, store] = useMovementStore()

  const lang = Lang.msg.movementTemplates
  const unsubscribeItemOptions = getRemoveAssignedOptions()
  const selected = unsubscribeItemOptions.find(
    i => i.key === state.unsubscribeItem
  )

  return (
    <>
      <TwAction>
        <Checkbox
          value={!!state.unsubscribe}
          text={lang.createUnsubscribeFromChat}
          onChange={store.unsubscribeChanged}
        />

        <div className="max-w-230 min-w-230 ml-auto">
          <SelectWithDropdown
            options={getRemoveAssignedOptions()}
            value={selected?.text || ''}
            size={menuItemHeight}
            disabled={!state.unsubscribe}
            width={'min-w-230 max-w-230'}
            onChange={store.unsubscribeItemChanged}
          />
        </div>
      </TwAction>

      {state.unsubscribe && state.unsubscribeItem === 'specific-users' && (
        <TwAction>
          <div className="max-w-230 min-w-230 ml-auto">
            <SelectWithUsers
              board={board}
              onChange={store.unsubscribeUsersChanged}
              selectedUserIds={state.unsubscribeUsers}
              placeholder={lang.placeholderUsers}
            />
          </div>
        </TwAction>
      )}

      <TwAction>
        <Checkbox
          value={!!state.subscribe}
          text={lang.createSubscribeFromChat}
          onChange={store.subscribeChanged}
        />

        <div className="max-w-230 min-w-230 ml-auto">
          {destBoard && (
            <SelectWithUsers
              board={destBoard}
              onChange={store.subscribeUsersChanged}
              selectedUserIds={state.subscribeUsers}
              disabled={!state.subscribe || !destBoard}
              placeholder={lang.placeholderUsers}
            />
          )}
        </div>
      </TwAction>
    </>
  )
})
